import { createSlice } from "@reduxjs/toolkit"

export interface UserWithData {
  _id: string;
  email: string;
  freeUser: boolean;
  businessess: BusinessesWithData[];
  scans: ScansWithData[];
  map_checkin_enabled: boolean
}

export interface BusinessesWithData {
  place_id: string;
  address: string;
  business_name: string;
  keywords: string[];
  added_by: string;
  updatedAt: string;
  createdAt: string;
  users: UserWithData[];
  scans: ScansWithData[];
}

export interface ScansWithData {
  businessess: BusinessesWithData[];
  users: UserWithData[];
  keyword: string;
  added_by: string;
  created_at: string;
  name: string;
}

interface AdminDashboardState {
  usersWithData: UserWithData[];
  businessesWithData: BusinessesWithData[];
  scanWithData: ScansWithData[];
  ctrBoosterWithData: any[];
  mapCheckInsData: any[];
  usersCount: number;
  businessCount: number;
  scansCount: number;
  loading: boolean;
  error: string | null;
  newUserData: any;
  newBusinessData: any;
  newScanData: any;
}

const initialState: AdminDashboardState = {
  usersWithData: [],
  businessesWithData: [],
  scanWithData: [],
  ctrBoosterWithData: [],
  mapCheckInsData: [],
  usersCount: 0,
  businessCount: 0,
  scansCount: 0,
  loading: false,
  error: null,
  newUserData: [],
  newBusinessData: [],
  newScanData: [],
}

export const AdminDashboardSlice = createSlice({
  name: 'AdminDashboardState',
  initialState,
  reducers: {},
  extraReducers: (builder) => { },
})

export default AdminDashboardSlice.reducer